// iConnect — Service area archive dispatch console (archive-service_area.php)
// Load after iconnect-service-area-map.js.
//
// Step 1: typing dims the suburb pills that don't match and highlights the
// first match on the map, by replaying the pill hover that
// iconnect-service-area-map.js listens to (the hub sends a pulse to it).
// Choosing a suburb (pill click, Enter, or a map dot) marks it .is-current,
// which the banner map styles draw as a lime target ring and route, and swaps
// the finder for the dispatch ticket (step 2). "Change" goes back to step 1.

const SVG_NS = 'http://www.w3.org/2000/svg';

document.querySelectorAll('.sa-archive__hero').forEach((hero) => {
    const finder = hero.querySelector('.sa-archive__finder');
    const ticket = hero.querySelector('.sa-archive__ticket');
    const input  = finder.querySelector('.sa-archive__search-input');
    const empty  = finder.querySelector('.sa-archive__empty');
    const steps  = hero.querySelectorAll('.sa-archive__step');
    const svg    = hero.querySelector('.iconnect-sam__svg');
    const pills  = [...finder.querySelectorAll('.iconnect-sam__pill')];
    const target = document.createElementNS(SVG_NS, 'circle');

    target.setAttribute('class', 'iconnect-sam__target');
    target.setAttribute('r', 22);

    let lit = null;

    const highlight = (pill) => {
        if (pill === lit) return;
        lit?.classList.remove('is-active');
        lit?.dispatchEvent(new Event('mouseleave'));
        pill?.classList.add('is-active');
        pill?.dispatchEvent(new Event('mouseenter'));
        lit = pill;
    };

    const showStep = (n) => {
        finder.hidden = n !== 1;
        ticket.hidden = n !== 2;
        steps.forEach((step, i) => step.classList.toggle('is-active', i === n - 1));
    };

    const clearCurrent = () => {
        svg.querySelectorAll('.is-current').forEach((el) => el.classList.remove('is-current'));
        target.remove();
    };

    const select = (pill) => {
        const slug = pill.dataset.slug;

        clearCurrent();
        const loc = svg.querySelector(`.iconnect-sam__loc[data-slug="${slug}"]`);
        if (loc) {
            loc.classList.add('is-current');
            loc.prepend(target);
            svg.querySelector(`.iconnect-sam__route[data-slug="${slug}"]`)?.classList.add('is-current');
        }

        highlight(pill);
        ticket.querySelectorAll('[data-suburb]').forEach((el) => { el.textContent = pill.textContent; });
        ticket.querySelector('[data-suburb-link]').href = pill.href;
        showStep(2);
        ticket.querySelector('.sa-archive__choice').focus();
    };

    input.addEventListener('input', () => {
        const term    = input.value.trim().toLowerCase();
        const matches = pills.filter((pill) => pill.textContent.toLowerCase().includes(term));

        pills.forEach((pill) => pill.classList.toggle('is-dim', !matches.includes(pill)));
        empty.hidden = matches.length > 0;
        highlight(term ? matches[0] ?? null : null);
    });

    finder.addEventListener('submit', (e) => {
        e.preventDefault();
        if (lit) select(lit);
    });

    pills.forEach((pill) => pill.addEventListener('click', (e) => {
        e.preventDefault();
        select(pill);
    }));

    // Map dots are links to the suburb page; choose the suburb instead.
    svg.querySelectorAll('a.iconnect-sam__loc').forEach((loc) => loc.addEventListener('click', (e) => {
        e.preventDefault();
        select(pills.find((pill) => pill.dataset.slug === loc.dataset.slug));
    }));

    hero.querySelector('.sa-archive__ticket-change').addEventListener('click', () => {
        clearCurrent();
        highlight(null);
        showStep(1);
        input.focus();
    });
});
